import type {GroupBase, OptionsOrGroups} from "react-select";

import {IOption} from "../types/IOption";
import {isMultiSelectValue} from "./is_multi_select_value";
import {isSelectOption} from "./is_select_option";

export const getSelectValue = <Value, Option extends IOption<Value>, IsMulti extends boolean, Group extends GroupBase<Option> = GroupBase<Option>>(
    value: Value | Value[],
    options: OptionsOrGroups<Option, Group> = [],
    isMulti?: IsMulti
) => {
    if (typeof value === "undefined" || value === null) {
        return value;
    }

    if (isMultiSelectValue(value, isMulti)) {
        const selected: Option[] = [];

        options.forEach((option) => {
            if (isSelectOption<Value, Option, Group>(option)) {
                if (value.includes(option.value)) {
                    selected.push(option);
                }

                return;
            }

            option.options.forEach((groupOption) => {
                if (value.includes(groupOption.value)) {
                    selected.push(groupOption);
                }
            });
        });

        return selected;
    }

    let selected: Option | undefined = undefined;

    for (const option of options) {
        if (isSelectOption<Value, Option, Group>(option)) {
            if (option.value === value) {
                selected = option;
            }
        } else {
            for (const groupOption of option.options) {
                if (groupOption.value === value) {
                    selected = groupOption;

                    break;
                }
            }
        }

        // Finish loop as soon as selected value will be found
        if (selected) {
            break;
        }
    }

    return selected;
};
